var globalRect = { x: 218, y: 124, width: 1309, height: 601 };

var resmRegions = [
  {
    title: "Global View",
    slug: "global",
    titleForOrdering: "aa",
    rect: { x: 218, y: 124, width: 1309, height: 601 },
  },

  {
    title: "Latin America",
    slug: "latam",
  },
  {
    title: "Asia Pacific",
    slug: "apac",
  },
  {
    title: "North America",
    slug: "noram",
  },
  {
    title: "Europe, the Middle East, and Africa",
    slug: "emea",
  },
  {
    title: "UK & Ireland",
    slug: "uki",
    rect: { x: 735.6, y: 129.5, width: 56.6, height: 52.8 },
  },
];

var resmData = [
  {
    title: "Canada",
    popuptitle: "Canada",
    slug: "canada",
    region: "noram",
    x: 297,
    y: 150,
    images: {},
    content:
      "DHL Supply Chain Canada is certified as a Great Place to Work, with corporate responsibility initiatives including blood drives across North America and Puerto Rico. DHL Supply Chain currently partners with five blood donation service organizations, including the American Red Cross, helping to save countless lives.<br>The DHL Supply Chain Future Leaders Scholarship, given to 17 third-year students studying supply chain or operations, IT/robotics and finance, is part of DHL Supply Chain&#146;s efforts to identify and foster the next generation of supply chain professionals. Each student receives a financial award to support their studies for the academic year.",
    urls: [
      {
        title: "Learn More | DHL Inaugural Future Leaders Scholarship",
        url: "https://www.dhl.com/us-en/home/press/press-archive/2022/dhl-supply-chain-supports-college-students-and-supply-chain-industry-through-inaugural-future-leaders-scholarship.html",
      },
    ],
    cluster: "noram",
  },
  {
    title: "United States of America",
    popuptitle: "United States of America",
    slug: "usa",
    region: "noram",
    x: 257,
    y: 250,
    images: {},
    content:
      "DHL Supply Chain USA is certified as a Great Place to Work, with corporate responsibility initiatives including blood drives across North America and Puerto Rico. It is currently partnering with five blood donation service organizations, including the American Red Cross, helping to save countless lives.<br>DHL Supply Chain, also supports Red Cross Disaster Relief through the Disaster Responder Program with an annual financial pledge and the deployment of employees to work in Red Cross disaster warehouses around the country when disasters strike. The business also partners with Girl Scouts USA to create a new logistics patch and curriculum aimed at inspiring female supply chain leaders of tomorrow.",
    urls: [
      {
        title: "Learn More | American Red Cross Partnership",
        url: "https://www.dhl.com/us-en/home/press/press-archive/2023/dhl-supply-chain-supports-american-red-cross-humanitarian-mission-through-disaster-responder-program.html",
      },
      {
        title: "Learn More | DHL Supply Chain Girl Scouts USA Partnership",
        url: "https://www.dhl.com/us-en/home/press/press-archive/2023/dhl-supply-chain-and-girl-scouts-of-the-usa-partner-to-create-new-logistics-patch-and-curriculum.html",
      },
    ],
    cluster: "noram",
  },
  {
    title: "Mexico",
    popuptitle: "Mexico",
    slug: "mexico",
    region: "latam",
    x: 219,
    y: 354,
    images: {},
    content:
      "DHL Supply Chain Mexico is certified as a Great Place to Work, due to its commitment to the well-being of not just its  employees, but their families and community as well.",
    urls: [],
    cluster: "noram",
  },
  {
    title: "Colombia",
    popuptitle: "Colombia",
    slug: "colombia",
    region: "latam",
    x: 369,
    y: 477,
    images: {},
    content:
      "DHL Supply Chain Colombia is certified as a Great Place to Work. The business has hosted roundtable sessions to share proposals, experiences and ideas about how to promote leadership by women within the company. These contributions are being used in the development of diversity and inclusion plans.",
    urls: [],
    cluster: "latam",
  },
  {
    title: "Peru",
    popuptitle: "Peru",
    slug: "peru",
    region: "latam",
    x: 357,
    y: 565,
    images: {},
    content:
      "DHL Supply Chain Peru has achieved Great Place to Work certification, with 91% of employees rating it as such. This recognition is a result of events such as its two weeks of Global Volunteering. This sees employees contribute to nearby communities by developing the employability skills of young people, rehabilitating public spaces, and contributing to achieving better living conditions for families in vulnerable situations.",
    urls: [],
    cluster: "latam",
  },
  {
    title: "Brazil",
    popuptitle: "Brazil",
    slug: "brazil",
    region: "latam",
    x: 500,
    y: 562,
    images: {},
    content:
      'DHL Supply Chain Brazil is certified as a Great Place to Work in South America. "This result confirms that we are on the right track with our people management and emphasizes that we are always ready to evolve, improve and innovate", said Ana Peregrino, Senior Manager of Human Resources.',
    urls: [],
    cluster: "latam",
  },
  {
    title: "Chile",
    popuptitle: "Chile",
    slug: "chile",
    region: "latam",
    x: 403,
    y: 719,
    images: {},
    content:
      "DHL Supply Chain Chile is officially a Great Place to Work, with 84% of employees ranking it as such. Certification has two big benefits. It sends a message to the labor market about the great experience of working there and gives customers the confidence to continue choosing DHL Supply Chain as their supplier.",
    urls: [],
    cluster: "latam",
  },
  {
    title: "Argentina",
    popuptitle: "Argentina",
    slug: "argentina",
    region: "latam",
    x: 438,
    y: 725,
    images: {},
    content:
      "DHL Supply Chain Argentina has achieved Great Place to Work certification with 87% of employees ranking it as such. It  attributes this to the recognition of its partners  as well as  the company&#146;s benefits and adoption of best practices.",
    urls: [],
    cluster: "latam",
  },
  {
    title: "Ireland",
    popuptitle: "Ireland",
    slug: "ireland",
    region: "uki",
    x: 747,
    y: 161,
    images: {},
    content:
      "DHL Supply Chain Ireland is certified as a Great Place to Work, with sustainability at the heart of the business. Its partnership with FoodCloud, the Irish social enterprise tackling the twin issues of food waste and food insecurity, will see the creation of volunteering and mentorship opportunities such as  driving, helping to pack food in warehouses and picking surplus crops from fields. The company is also able to mentor FoodCloud by providing expertise on route optimisation, driver planning and emissions capture to enhance efficiency. Along with DHL Express and DHL Global Forwarding, DHL Supply Chain Ireland has a partnership with the Elephant in the Room movement, a local initiative aimed at destigmatizing mental health and promoting open conversations.<br>The Elephant in the Room movement encourages individuals to discuss their mental health as openly as they would any physical ailment. By supporting this movement, DHL aims to create a safe and supportive environment where employees can address their mental health concerns without fear of judgment or discrimination.",
    urls: [
      {
        title:
          "Learn More | DHL Ireland Joins Forces With Elephant in the Room Movement",
        url: "https://www.dhl.com/ie-en/home/press/press-archive/2024/dhl-ireland-joins-forces-with-elephant-in-the-room-movement-to-promote-mental-health-awareness.html",
      },
    ],
    cluster: "emea",
  },
  {
    title: "Spain",
    popuptitle: "Spain",
    slug: "spain",
    region: "emea",
    x: 762,
    y: 244,
    images: {},
    content:
      "DHL Supply Chain Spain is certified as a Great Place to Work for a fourth consecutive year with 85% of employees ranking it as such due to its human resources practices, employee events and volunteering opportunities. Reinforcing the GoGreen program, its GoGreen volunteering opportunities saw employees work as volunteers to protect the biodiversity of the Montnegre i el Corredor Park in the Catalan coastal mountain range and refurbish facilities at childrens&#146; villages for the disadvantaged.",
    urls: [
      {
        title: "Discover | Festival Mi Vocación",
        url: "https://youtu.be/xoPbHe4HgM8",
      },
    ],
    cluster: "emea",
  },
  {
    title: "India",
    popuptitle: "India",
    slug: "india",
    region: "apac",
    x: 1220,
    y: 360,
    images: {},
    content:
      "DHL Supply Chain India is proud to have achieved Great Place to Work certification for the eight consecutive year. This achievement and the consistent improvement in ranking is testament to the dedication, effort and feedback of all our employees in India who have helped us build a culture of Respect and Results. A Persons with Disabilities (PWD) project has seen the workforce undergo training to ensure that when hiring a more diverse workforce, all team members are supported and made to feel they belong.",
    urls: [
      {
        title:
          "Discover | Sameer Gaikwad Inspiring Diversity & Inclusion from within",
        url: "https://dhlinsights.dhlsupplychain.dhl.com/ao_employer-brand/video_sameer-gaikwad",
      },
    ],
    cluster: "",
  },
  {
    title: "Thailand",
    popuptitle: "Thailand",
    slug: "thailand",
    region: "apac",
    x: 1353,
    y: 401,
    images: {},
    content:
      "DHL Supply Chain Thailand is certified as a Great Place to Work, with 84% of employees rating it as such, compared to 53% at a typical global company. Through the GoTeach program and in collaboration with SOS Children&#146;s Villages Thailand, DHL has brought to life the DHL Entrepreneurship Bootcamp. With a  focus on developing youth skillsets for employment and job readiness, the bootcamp promoted essential skills for entrepreneurs after a survey found that the dream of young people was to follow an entrepreneurial path. At DHL, we have the same goal of inspiring young individuals and providing them with optimal resources to pursue their dreams.",
    urls: [],
    cluster: "aspac",
  },
  {
    title: "Malaysia",
    popuptitle: "Malaysia",
    slug: "malaysia",
    region: "apac",
    x: 1361,
    y: 475,
    images: {},
    content:
      "DHL Supply Chain Malaysia is one of a record 11 DHL countries in Asia Pacific to be ranked as a Great Place to Work. The business has steadfastly promoted a #ConnectedPeople culture in which respect, pride, credibility, camaraderie and fairness are encouraged and celebrated, with 87% of employees ranking it as meeting those aspirations.",
    urls: [],
    cluster: "aspac",
  },
  {
    title: "Vietnam",
    popuptitle: "Vietnam",
    slug: "vietnam",
    region: "apac",
    x: 1391,
    y: 429,
    images: {},
    content:
      "DHL Supply Chain Vietnam is certified as a Great Place to Work. 92% of employees say it&#146;s a Great Place to Work, compared to 53% of employees at a typical global company and it was ranked 3rd place in Vietnam's Best Workplaces based on survey results from 2023. This achievement highlights a commitment to a culture that balances 'Respect and Results,' ensuring an inclusive workplace where everyone is heard and valued.",
    urls: [],
    cluster: "aspac",
  },
  {
    title: "Singapore",
    popuptitle: "Singapore",
    slug: "singapore",
    region: "apac",
    x: 1373,
    y: 493,
    images: {},
    content:
      "DHL Supply Chain Singapore is ranked as a Great Place to Work thanks to initiatives such as the Red Cross (SRC) Infant Care Packages project. This volunteering initiative falls under the GoHelp initiative, where the various DHL business units work together to give back to society through our logistics expertise. Each month, volunteers pack and distribute care packages to vulnerable families with young toddlers and infants.",
    urls: [
      {
        title: "Discover | Singapore Red Cross Partnership",
        url: "https://dhlinsights.dhlsupplychain.dhl.com/ao_employer-brand/video_dhl-Singapore-delivers-infant-essentials",
      },
    ],
    cluster: "aspac",
  },
  {
    title: "Indonesia",
    popuptitle: "Indonesia",
    slug: "indonesia",
    region: "apac",
    x: 1442,
    y: 517,
    images: {},
    content:
      'DHL Supply Chain Indonesia has achieved Great Place to Work #1 Best Workplaces in 2023, and continues its work to deliver an excellent employee experience in 2024, with over 90% of employees saying that it is a great place to work. Why? "Our commitment to providing equal treatment and opportunities for everyone through personal learning, individual development and a career journey are the key factors that drive our diversity culture."',
    urls: [
      {
        title: "Discover | DHL Supply Chain #1 Indonesia Best Workplaces 2023",
        url: "https://youtu.be/8xHFMNUCDcE?feature=shared",
      },
    ],
    cluster: "aspac",
  },
  {
    title: "Taiwan",
    popuptitle: "Taiwan",
    slug: "taiwan",
    region: "apac",
    x: 1453,
    y: 350,
    images: {},
    content:
      "DHL Supply Chain Taiwan is certified as a Great Place to Work, with 82% of employees rating it as such.<br>Andries Retief, formerly CEO South East Asia, said: &#147;At DHL we have a very strong focus on belonging and I think everyone deserves to feel that sense of belonging no matter what form of diversity we are talking about, including mental health. At DHL, we don&#146;t attach stigmas and it is okay to share your story and work through mental health topics.&#148;",
    urls: [
      {
        title: "Learn More | Feeling Alright is Everyone&#146;s Right",
        url: "https://dhlinsights.dhlsupplychain.dhl.com/ao_employer-brand/article_world-mental-health-day-2023-feeling-alright-is-everyones-right",
      },
    ],
    cluster: "aspac",
  },
  {
    title: "Philippines",
    popuptitle: "Philippines",
    slug: "philippines",
    region: "apac",
    x: 1481,
    y: 428,
    images: {},
    content:
      "DHL Supply Chain Philippines has been recognized as a Great Place to Work. Since 2013, DHL has supported students and teachers from Teach for the Philippines with internships, career planning sessions and mentoring. Under a partnership with SOS Children&#146;s Villages, DHL employees/volunteers will work to mentor youths as they transition to the working world. The activities include job orientation to help young people understand the job market, soft and basic skills training to improve employability, and entrepreneurship to empower them to become independent and make their dreams come true.",
    urls: [],
    cluster: "aspac",
  },
  {
    title: "Australia",
    popuptitle: "Australia",
    slug: "australia",
    region: "apac",
    x: 1528,
    y: 663,
    images: {},
    content:
      'DHL Supply Chain Australia has been certified as a Great Place to Work for the fourth consecutive year and was recognized as the 7th Best Workplace in Australia by Great Place to Work 2023. Rachael McDonald, Vice President of HR said: "Being certified as a Great Place to Work is testament to our employees and the culture they embody. Discovering and nurturing the potential of every one of our employees is important to us and we provide plenty of opportunities to develop, with certified programs and on-the-job training. We pride ourselves on ensuring all employees have direct access to development, tools, information and support to achieve their goals. Our strong, inclusive culture is fostered through a continuous focus on respect, results and employee engagement."',
    urls: [],
    cluster: "",
  },
  {
    title: "New Zealand",
    popuptitle: "New Zealand",
    slug: "newzealand",
    region: "apac",
    x: 1679,
    y: 771,
    images: {},
    content:
      "DHL Supply Chain NZ has been certified as a Great Place to Work for three years in a row. Rose Johnson, Director Human Resources said &#147;Being certified as a Great Place to Work is testament to our people embracing our culture of driving for results without compromising on respect. Our Great Place to Work results confirmed that our people feel safe, included, take pride in progressing our ESG agenda and working for DHL. We provide ample opportunity for our team members to learn and grow from the frontline upwards with a dedicated focus on talent development and access to world class learning and development programmes, tools and resources. Most of all, this result tells us our people know we genuinely care.&#148;",
    urls: [],
    cluster: "",
  },
  {
    title: "South Korea",
    popuptitle: "South Korea",
    slug: "southkorea",
    region: "apac",
    x: 1464,
    y: 269,
    images: {},
    content:
      "DHL Supply Chain South Korea was ranked in the 2023 Best Workplaces in Korea, and this year, increased its score by 14 percentage points. In addition, site manager Ines Choi has been selected in the &#146;Proud Working Mothers in Korea&#146; category, which recognizes working mothers in  leadership positions despite the various restrictions they face in  maintaining a work-family balance.<br>Ines said: &#147;Being a woman at DHL is not difficult because our company has a culture that values and embraces diversity among all ages, genders and races. Everyone respects me as an operations manager and a site manager.&#148;",
    urls: [],
    cluster: "",
  },
  {
    title: "Czech Republic",
    popuptitle: "Czech Republic",
    slug: "czechrepublic",
    region: "emea",
    x: 858,
    y: 183,
    images: {},
    content:
      "DHL Supply Chain in the Czech Republic is proud to be recognized as a Great Place to Work, something that is reflected in its partnership with the annual One World festival in Olomouc which highlights the importance of human rights. After the outbreak of war in Ukraine, the company helped refugees with financial donations, counselling and  transportation of more than a hundred women and children from all parts of Ukraine to the Czech Republic where many found work in DHL distribution centers.",
    urls: [],
    cluster: "emea",
  },
  {
    title: "Italy",
    popuptitle: "Italy",
    slug: "italy",
    region: "emea",
    x: 849,
    y: 228,
    images: {},
    content:
      "DHL Supply Chain Italy is certified as a Great Place to Work with the recruitment of around 1,500 employees in under two years. The team places a strong focus on safety, learning and engagement, strengths that drive its competitiveness together with the  attention that is dedicated to sustainability and corporate responsibility  projects.",
    urls: [],
    cluster: "emea",
  },
  {
    title: "Netherlands",
    popuptitle: "Netherlands",
    slug: "netherlands",
    region: "emea",
    x: 810,
    y: 169,
    images: {},
    content:
      "DHL Supply Chain Netherlands is a Great Place to Work and prides itself on its employee experience. The GoAbroad program has enabled frontline workforce members to relocate to sites across Germany, the Netherlands and Belgium on short-term contracts giving employees a chance to experience more of the company within a different geography, while its thriving graduate program supports recently graduated students as they begin their journey in the workplace.",
    urls: [
      {
        title: "Learn More | DHL GoAbroad program",
        url: "https://dhlinsights.dhlsupplychain.dhl.com/ao_employer-brand/case-study_cross-border-hr-program-meets-customer-need-providing-great-employee-experience",
      },
    ],
    cluster: "emea",
  },
  {
    title: "Poland",
    popuptitle: "Poland",
    slug: "poland",
    region: "emea",
    x: 877,
    y: 170,
    images: {},
    content:
      "DHL Supply Chain Poland is a Great Place to Work, with a focus on corporate social responsibility  and alignment with the GoHelp and GoTeach initiatives. Poland is the host country for a DHL Supply Chain European football tournament which is being held for the third time, gathering 250 participants and includes 22 teams from Poland, Czech Republic, Slovakia, Hungary and Turkey.",
    urls: [],
    cluster: "emea",
  },
  {
    title: "Saudi Arabia",
    popuptitle: "Saudi Arabia",
    slug: "saudiarabia",
    region: "emea",
    x: 1032,
    y: 350,
    images: {},
    content:
      "DHL Supply Chain in Saudi Arabia is proud to have been certified as a Great Place to Work for a third consecutive year with 89% of employees ranking it as such. The achievement has driven its teams to reach even greater levels of excellence on behalf of its customers and achieve even higher levels of employee satisfaction.",
    urls: [],
    cluster: "emea",
  },
  {
    title: "Turkey",
    popuptitle: "Turkey",
    slug: "turkey",
    region: "emea",
    x: 972,
    y: 252,
    images: {},
    content:
      "DHL Supply Chain in Turkey has been certified as a Great Place to Work, receiving a score of  92%.<br>The certification is a great source of pride for the team, and is regarded as the best indicator of the happiness and satisfaction of employees. DHL Group's GoHelp program is making a significant impact in Europe. When natural disasters strike, GoHelp ensures the seamless flow of aid in affected regions. With the recent completion of the first Disaster Response Team (DRT) training at Istanbul Airport, DHL is expanding its commitment to providing logistics expertise for global relief efforts.",
    urls: [
      {
        title: "Learn More | DHL Group expands GoHelp program to Europe",
        url: "https://group.dhl.com/en/media-relations/press-releases/2024/dhl-group-expands-gohelp-program-europe-trains-disaster-response-team-istanbul-international-airport.html?nu_ref=Oktopost-LinkedIn&utm_campaign=0323_Global_Press-release_general_Awareness_ENSOGV_OS&utm_content=LinkedIn-DHL+Supply+Chain&utm_medium=Social-Media&utm_source=LinkedIn",
      },
    ],
    cluster: "emea",
  },
  {
    title: "United Kingdom",
    popuptitle: "United Kingdom",
    slug: "unitedkingdom",
    region: "uki",
    x: 777,
    y: 168,
    images: {},
    content:
      "DHL Supply Chain has been certified a Great Place to Work, with both the UK and Ireland qualifying for the award. This is a result of initiatives such as the DHL UK Foundation. The Foundation works with DHL colleagues across the UK to help charities and school partners ensure that disadvantaged young people have access to the best possible education, develop essential life skills and have the opportunity to secure meaningful and sustainable employment. Elsewhere, colleagues have spent over 450 hours helping to keep their communities clean individually or with their teams, family and friends as part of a #GoCleanGoGreen initiative.",
    urls: [
      {
        title: "Learn More | DHL UK Foundation",
        url: "https://www.dhlukfoundation.org/",
      },
    ],
    cluster: "emea",
  },
  {
    title: "Belgium",
    popuptitle: "Belgium",
    slug: "belgium",
    region: "emea",
    x: 807,
    y: 179,
    images: {},
    content:
      "DHL Supply Chain Belgium has been certified as a Great Place To Work, recognizing DHL&#146;s continuing commitment to a people-first culture. The GoAbroad program has enabled frontline workforce members to relocate to sites across Germany, the Netherlands and Belgium on short-term contracts, giving employees a chance to experience more of the company within a different geography, while its thriving graduate program supports recently graduated students as they begin their journey in the workplace.",
    urls: [
      {
        title: "Learn More | DHL GoAbroad Program",
        url: "https://dhlinsights.dhlsupplychain.dhl.com/ao_employer-brand/case-study_cross-border-hr-program-meets-customer-need-providing-great-employee-experience",
      },
    ],
    cluster: "emea",
  },
  {
    title: "Finland",
    popuptitle: "Finland",
    slug: "finland",
    region: "emea",
    x: 901,
    y: 103,
    images: {},
    content:
      "DHL Supply Chain Finland is certified as a Great Place to Work. Its employees recognize that they are all working towards the same goal and praise the development opportunities that they have. DHL Supply Chain supports personal development, and employees who want to learn new skills are given opportunities to do so, from day one. Achieving certification shows that HR practices meet the highest global standards and that together the team creates an excellent workplace.",
    urls: [],
    cluster: "emea",
  },
  {
    title: "France",
    popuptitle: "France",
    slug: "france",
    region: "emea",
    x: 795,
    y: 206,
    images: {},
    content:
      "DHL Supply Chain in France has achieved Great Place to Work certification with 84% of employees ranking it as such. This is due to its strong health and safety emphasis, focus on local social projects, diverse and inclusive workplace, and financial incentives for employees when targets are achieved.",
    urls: [],
    cluster: "emea",
  },
  {
    title: "Germany",
    popuptitle: "Germany",
    slug: "germany",
    region: "emea",
    x: 831,
    y: 175,
    images: {},
    content:
      "DHL Supply Chain Germany has been certified as a Great Place to Work. The Great Place to Work Certification is based on results of the Trust Index survey administered by the Great Place to Work Institute, which assesses employee satisfaction in key areas, from credibility and respect to fairness and camaraderie. Germany is proud to be certified alongside 15 other countries in the Europe, Middle East and Africa region at DHL.",
    urls: [],
    cluster: "emea",
  },
  {
    title: "Hungary",
    popuptitle: "Hungary",
    slug: "hungary",
    region: "emea",
    x: 883,
    y: 202,
    images: {},
    content:
      "DHL Supply Chain Hungary has been certified a Great Place to Work due to its HR approach, employee events and volunteering opportunities. In September, for the third year in a row, over 400 employees will participate in the charitable DHL Supply Chain CEE Run which will benefit the SOS Wioski Dziecięce organization and will see nearly 1,000 trees planted. The charity run, taking place in four countries – Poland, the Czech Republic, Slovakia and Hungary – is part of the GoGreen sustainable development strategy and corporate social responsibility program. Alongside fundraising for charity, the project also ensures that one tree is planted for each 10km covered.",
    urls: [],
    cluster: "emea",
  },
  {
    title: "Portugal",
    popuptitle: "Portugal",
    slug: "portugal",
    region: "emea",
    x: 741,
    y: 252,
    images: {},
    content:
      "DHL Supply Chain Portugal has been certified a Great Place to Work and is steadfast in its commitment to create a workplace that provides fair treatment, equal opportunities, and fosters a strong sense of connection among all. For the second consecutive year, DHL Supply Chain Portugal invited all employees and their children to participate in a festival and activities that aimed to promote health and well-being while giving them the chance to relax and enjoy themselves. The team provides a stable, secure place to work that offers employees plenty of opportunities to learn, grow and develop their skills.",
    urls: [],
    cluster: "emea",
  },
  {
    title: "Puerto Rico",
    popuptitle: "Puerto Rico",
    slug: "puertorico",
    region: "noram",
    x: 413,
    y: 385,
    images: {},
    content:
      "DHL Supply Chain Puerto Rico has achieved Great Place to Work certification with 90% of employees ranking it as such. This results from collective efforts, shared values, and commitment to creating an inclusive and supportive work environment, along with corporate responsibility initiatives including blood drives across Puerto Rico and North America.",
    urls: [],
    cluster: "noram",
  },
  {
    title: "Slovakia",
    popuptitle: "Slovakia",
    slug: "slovakia",
    region: "emea",
    x: 879,
    y: 190,
    images: {},
    content:
      "DHL Supply Chain Slovakia has achieved Great Place To Work certification, affirming its commitment to being the first choice for its employees and a reflection of the company being a great place to work for all. Slovakia participates in the DHL Supply Chain Soccer Cup CEE, showcasing the lighter side of its talented employees and providing a chance to display soccer skills, build connections, foster teamwork, and have a good time. In September, for the third year in a row, over 400 employees will participate in the charitable DHL Supply Chain CEE Run, benefitting the SOS Wioski Dziecięce organization. The charity run, taking place in four countries – Poland, the Czech Republic, Slovakia and Hungary – is part of the GoGreen sustainable development strategy and corporate social responsibility. Alongside fundraising for charity, the project also ensures that one tree is planted for each 10km covered.",
    urls: [],
    cluster: "emea",
  },
  {
    title: "Sweden",
    popuptitle: "Sweden",
    slug: "sweden",
    region: "emea",
    x: 852,
    y: 116,
    images: {},
    content:
      "DHL Supply Chain Sweden is certified as a Great Place to Work, due to its commitment to the well-being of not just its employees, but their families and community as well. Its employees recognize that they are all working towards the same goal and praise the development opportunities that they have. DHL Supply Chain supports personal development, and employees who want to learn new skills are given opportunities to do so, from day one.",
    urls: [],
    cluster: "emea",
  },
];

var clusterData = [
  {
    slug: "emea",
    count: 8,
    x: 794,
    y: 165,
    zoom_hide: 0.5,
    zoom_show: 0,
    scale: 1,
    end_scale: 2.5,
  },
  {
    slug: "aspac",
    count: 7,
    x: 1414,
    y: 435,
    zoom_hide: 0.5,
    zoom_show: 0,
    scale: 1,
    end_scale: 2.5,
  },
  {
    slug: "latam",
    count: 5,
    x: 424,
    y: 575,
    zoom_hide: 0.5,
    zoom_show: 0,
    scale: 1,
    end_scale: 2.5,
  },
  {
    slug: "noram",
    count: 3,
    x: 257,
    y: 250,
    zoom_hide: 0.5,
    zoom_show: 0,
    scale: 1,
    end_scale: 2.5,
  },
];

resmData.sort(function (a, b) {
  if (a.title.toLowerCase() < b.title.toLowerCase()) {
    return -1;
  }
  if (a.title.toLowerCase() > b.title.toLowerCase()) {
    return 1;
  }
  return 0;
});

// modified ordering, take into account titleForOrdering so we can override ordering
resmRegions.sort(function (a, b) {
  var aTitle = a.titleForOrdering ? a.titleForOrdering : a.title;
  var bTitle = b.titleForOrdering ? b.titleForOrdering : b.title;
  if (aTitle.toLowerCase() < bTitle.toLowerCase()) {
    return -1;
  }
  if (aTitle.toLowerCase() > bTitle.toLowerCase()) {
    return 1;
  }
  return 0;
});
